import { combineReducers } from 'redux';

import { uiConstants } from '../constants';

const ccassPage = (
  state = {
    date: new Date(),
    compareDate: undefined,
    stockCode: '',
    stockName: '',
    participantID: '',
    participantName: '',
  },
  action
) => {
  switch (action.type) {
    case uiConstants.PAGE_CCASS_DATE_CHANGED: {
      const { date } = action;
      return { ...state, date };
    }

    case uiConstants.PAGE_CCASS_COMPARE_DATE_CHANGED: {
      const { date } = action;
      return { ...state, compareDate: date };
    }

    case uiConstants.PAGE_CCASS_STOCKCODE_CHANGED: {
      return { ...state, stockCode: action.stockCode };
    }

    case uiConstants.PAGE_CCASS_STOCKNAME_CHANGED: {
      return { ...state, stockName: action.stockName };
    }

    case uiConstants.PAGE_CCASS_PARTICIPANTID_CHANGED: {
      return { ...state, participantID: action.participantID };
    }

    case uiConstants.PAGE_CCASS_PARTICIPANTNAME_CHANGED: {
      return { ...state, participantName: action.participantName };
    }

    default: {
      return state;
    }
  }
};

const stockPage = (
  state = {
    stockCode: '',
  },
  action
) => {
  if (action.type === uiConstants.PAGE_STOCK_STOCKCODE_CHANGED) {
    return { ...state, stockCode: action.stockCode };
  }

  return state;
};

const freeUserAlert = (
  state = {
    showParticipantNumberChangeFilterAlert: false,
    showPriceRangeFilterAlert: false,
  },
  action
) => {
  if (action.type === uiConstants.SET_FREEUSER_ALERT) {
    return {
      ...state,
      [action.key]: action.value,
    };
  }

  return state;
};

const updater = (
  state = {
    forceUpdate: false,
  },
  action
) => {
  if (action.type === uiConstants.FORCE_CLIENT_UPGRADE) {
    return { forceUpdate: true };
  }

  return state;
};

const floatTutorial = (
  state = { tutorialId: null, showQuestionMarks: false },
  action
) => {
  switch (action.type) {
    case uiConstants.SET_FLOAT_TUTORIAL_ID: {
      return { ...state, tutorialId: action.tutorialId };
    }

    case uiConstants.SET_QUESTION_MARK_VISIBLE: {
      return { ...state, showQuestionMarks: action.showQuestionMarks };
    }

    default: {
      return state;
    }
  }
};

export default combineReducers({
  ccassPage,
  updater,
  stockPage,
  floatTutorial,
  freeUserAlert,
});
